import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ErrorsExpansionPanelComponent } from './errors-expansion-panel.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatExpansionModule,
    MatIconModule,
    MatListModule
  ],
  declarations: [
    ErrorsExpansionPanelComponent
  ],
  exports: [
    ErrorsExpansionPanelComponent
  ]
})
export class ErrorsExpansionPanelModule { }
